const {version: appVersion} = require('../../package.json');
import {Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';
import {NotificationService} from './services';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../environments/environment';
import { HeaderComponent } from './_global/header/header.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: true,
    imports: [NgIf, HeaderComponent, RouterOutlet]
})
export class AppComponent implements OnInit {
  public externalApplication = false;
  public appVersion;
  token: string;

  constructor(public oauthService: OAuthService,
              public toastr: ToastrService,
              private activatedRoute: ActivatedRoute,
              public notificationService: NotificationService,
              public router: Router) {
    // this.configureAuth();

    // this.toastr.setRootViewContainerRef(vRef);
    this.appVersion = appVersion;
    this.notificationService.toastAlert.subscribe(next => {
      const defaultOpts = {positionClass: 'toast-bottom-right', enableHtml: true};
      if (next.type === 'success') {
        this.toastr.success(next.message, next.title, next.options || defaultOpts);
      } else if (next.type === 'warn') {
        this.toastr.warning(next.message, next.title, next.options || defaultOpts);
      } else if (next.type === 'error') {
        this.toastr.error(next.message, next.title, next.options || defaultOpts);
      } else {
        this.toastr.info(next.message, next.title, next.options || defaultOpts);
      }
    });

    if (sessionStorage.getItem('auth')) {
      environment.auth.active = JSON.parse(sessionStorage.getItem('auth'));
    }
  }

  public onActivate(event) {
    if (event.token === null) {
      this.token = null;
    }
  }

  public inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  ngOnInit() {
    this.externalApplication = this.inIframe();
    this.token = this.oauthService.getAccessToken();
  }
}
